import * as Redux from 'redux'
import * as Form from '../../components/form'
import * as Request from '../../request'
import * as Constants from './constants'
import * as Types from './types'

export const fetchReferralCampaigns = (community: string) =>
Request.requestActionCreator(Constants.FETCH_CAMPAIGNS)({
  method: 'GET',
  url: `${Constants.SERVER_HOME}/${community}`,
})

export const updateReferralCampaign = (community: string, payload: Types.Campaign) =>
Request.requestActionCreator(Constants.UPDATE_CAMPAIGN)({
  method: 'PUT',
  payload,
  url: `${Constants.SERVER_HOME}/${community}`,
})

export const createReferralCampaign = (community: string, payload: Types.Campaign) =>
Request.requestActionCreator(Constants.UPDATE_CAMPAIGN)({
  method: 'POST',
  payload,
  url: `${Constants.SERVER_HOME}/${community}`,
})

export const updateReferralCampaignTier = (community: string, payload: Types.Tier) =>
Request.requestActionCreator(Constants.UPDATE_CAMPAIGN_TIER)({
  method: 'PUT',
  payload,
  url: `${Constants.SERVER_HOME}/tier/${community}`,
})

export const createReferralCampaignTier = (community: string, payload: Types.Tier) =>
Request.requestActionCreator(Constants.UPDATE_CAMPAIGN_TIER)({
  method: 'POST',
  payload,
  url: `${Constants.SERVER_HOME}/tier/${community}`,
})
export interface SelectCampaign extends Redux.Action {
  campaign: Types.Campaign
}
export const selectCampaign = (campaign: Types.Campaign) => ({type: Constants.SELECT_CAMPAIGN, campaign})
export const CampaignFormActions = Form.createActionsMap(Constants.CAMPAIGN_FORM)
export const TierFormActions = Form.createActionsMap(Constants.TIER_FORM)

export interface TierClickAction extends Redux.Action {
  currentCampaign: Types.Campaign,
  clickedTier: Types.Tier,
}
export type TierClickFn = (currentCampaign: Types.Campaign, clickedTier: Types.Tier) => TierClickAction
export const onTierClick: TierClickFn = (currentCampaign: Types.Campaign, clickedTier: Types.Tier) =>
  ({type: Constants.TIER_CLICK, currentCampaign, clickedTier})



// WEBPACK FOOTER //
// ./src/pages/referral-campaigns/actions.ts